// LCMRS header scroll behaviour
(function () {
  var header = document.getElementById('lcmrs-header');
  if (!header) return;
  if (!header.classList.contains('lcmrs-header--homepage')) return;

  var hero = document.getElementById('lcmrs-hero');

  function getThreshold() {
    return hero ? hero.offsetHeight - header.offsetHeight : window.innerHeight * 0.9;
  }

  function onScroll() {
    if (window.scrollY >= getThreshold()) {
      header.classList.add('lcmrs-header--scrolled');
    } else {
      header.classList.remove('lcmrs-header--scrolled');
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
})();
